<template>
  <div :class="`level-${currentHeight % 8}`">
    <b-row v-if="currentHeight != 0 && item" class="mr-0">
      <b-col class="pr-0">
        <strong>{{item.product_id == 0 ? item.part_num : item.product_num}}:</strong>
        {{item.product_id == 0 ? item.part_desc : item.product_desc}}
        <em>{{(item.child_hierarchy != undefined && item.child_hierarchy.length > 0 ? item.part_id == 0 ? 'KIT' : 'BOM' : 'IND')}}</em>
        <span v-if="item.location">@ {{item.location}}</span>
        <strong> - Needs {{item.qty_needed}} {{item.uom}}</strong>
      </b-col>
      <b-col class="text-right my-1 pr-0" v-if="item.child_hierarchy != null && item.child_hierarchy.length > 0" cols=2>
        <b-btn size=sm @click="() => { this.showChildren = !this.showChildren }">
          {{this.showChildren ? 'Collapse' : 'Expand' }}
        </b-btn>
      </b-col>
    </b-row>

    <b-list-group flush v-if="showChildren" >
      <b-list-group-item v-for="it in item.child_hierarchy" :key="`${it.part_id}|${it.product_id}`" class="py-1 pr-0">
        <deep-bom-info-item :item="it" :currentHeight="currentHeight+1" />
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  name: 'deep-bom-info-item',
  props: {
    currentHeight: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      showChildren: true,
    }
  }
}
</script>

<style>
.level-1 {
  background-color: rgba(255,0,0,.3)
}
.level-2 {
  background-color: rgba(255,165,0,.3)
}
.level-3 {
  background-color: rgba(255,255,0,.3)
}
.level-4 {
  background-color: rgba(0,128,0,.3)
}
.level-5 {
  background-color: rgba(0,0,255,.3)
}
.level-6 {
  background-color: rgba(75,0,130,.3)
}
.level-7 {
  background-color: rgba(238,130,238,.3)
}

</style>


// WEBPACK FOOTER //
// src/components/inventory/DeepBomInfoItem.vue